import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, MdrOffUs, MdrOnUs, MdrQrisOffUs, MdrQrisOnUs, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { ApiDeleteEdc, ApiGetBeneficiaryAccountList, ApiGetCustomerPaymentById, ApiGetEdcList, ApiGetTransaction, ApiGetTransactionCustomerCard, ApiInsertEdc, ApiUpdateCustomerPayment, ApiUpdateEdc, ApiUpdateTransaction } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { decimal, GetStatus, money, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import { useCallApi } from "api/apiHooks"
import { useModal } from "utils/context/ModalContext"
import { useVariable } from "utils/context/VariableContext"

export default function TransferFormModal({ isOpen, onClose, data, customerPaymentId, formType }) {
    const navigate = useNavigate()

    const { transferSourceOptions } = useVariable()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCustomerPaymentById, fetchBeneficiaryList, fetchUpdateCustomerPayment } = useCallApi()

    const { fetch: deleteEdc } = useFetch(ApiDeleteEdc)
    const { fetch: apiGetCustomerPaymentById } = useFetch(ApiGetCustomerPaymentById)
    const { fetch: apiGetBeneficiaryList } = useFetch(ApiGetBeneficiaryAccountList)
    const { fetch: apiUpdateCustomerPayment } = useFetch(ApiUpdateCustomerPayment)

    let queryString = new URLSearchParams(window.location.search)
    // let formType = queryString.get("formType")
    let paramEdcId = queryString.get("edcId")

    const [transactionType, setTransactionType] = useState(MdrOnUs);
    const [mdrEdcOnUs, setMdrEdcOnUs] = useState(EmptyString)
    const [mdrEdcOffUs, setMdrEdcOffUs] = useState(EmptyString)
    const [mdrQrisOnUs, setMdrQrisOnUs] = useState(EmptyString)
    const [mdrQrisOffUs, setMdrQrisOffUs] = useState(EmptyString)
    const [transactionDate, setTransactionDate] = useState(null)
    const [customerCard, setCustomerCard] = useState(EmptyString)
    const [edc, setEdc] = useState(EmptyString)

    const [customerName, setCustomerName] = useState(EmptyString)
    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [gesekAmount, setGesekAmount] = useState(EmptyString)
    const [amount, setAmount] = useState(EmptyString)
    const [trMdr, setTrMdr] = useState(EmptyString)
    const [netto, setNetto] = useState(EmptyString)
    const [beneficiaryOptions, setBeneficiaryOptions] = useState([])
    const [selectedBeneficiaryOptions, setSelectedBeneficiaryOptions] = useState(EmptyString)
    const [selectedTransferSource, setSelectedTransferSource] = useState({label: EmptyString, value: EmptyString})
    const [remark, setRemark] = useState(EmptyString)
    const [bankCode, setBankCode] = useState(EmptyString)
    const [edcName, setEdcName] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [timeHour, setTimeHour] = useState(EmptyString)
    const [timeMinute, setTimeMinute] = useState(EmptyString)

    const [errorBeneficiaryAccountNo, setErrorBeneficiaryAccountNo] = useState(false)
    const [errorMdrOff, setErrorMdrOff] = useState(false)
    
    const amountChange = (e) => {
        setAmount(money(e.target.value))        
    }
    const beneficiaryOnInput = (e) => {
        fetchBeneficiaryList(
            '',
            e, 
            0,
            StatusCodeActive,
            100000,
            0
        ).then((res) => {
            if (!res) return

            let data = res.data.listData

            if (data.length > 0){
                let tempArray = []

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].accountName + " - " + data[i].bankCode + " (" + data[i].accountNo + ")", value: String(data[i].beneficiaryId) })
                }

                setBeneficiaryOptions(tempArray)
            }
        })
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Function Api Call
    const getBeneficiaryList = async(search) => {
        await apiGetBeneficiaryList({
            data: {
                accountNo: EmptyString,
                accountName: search, 
                bankId: 0,
                status: StatusCodeActive,
                pageSize: 100000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].accountName + " - " + data[i].bankCode + " (" + data[i].accountNo + ")", value: String(data[i].beneficiaryId) })
                    }

                    setBeneficiaryOptions(tempArray)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    const res = await fetchUpdateCustomerPayment(
                        customerPaymentId,
                        selectedBeneficiaryOptions.value,
                        amount.replaceAll(",", ""), 
                        selectedTransferSource.value,
                        remark
                    )

                    if (!res) return
                } finally {
                    hideLoading()
                }
                
                showSuccess({
                    onSuccess: () => {
                        onClose()
                    }
                })
            }
        }
    }
    const deleteBtnClick = async () => {
        // const isConfirmed = await confirm()

        // if (isConfirmed) {
        //     showLoading()

        //     try {
        //         const res = await fetchUpdateCustomerPayment(
        //             customerPaymentId,
        //             selectedBeneficiaryOptions.value,
        //             amount.replaceAll(",", ""), 
        //             selectedTransferSource.value,
        //             remark
        //         )

        //         if (!res) return
        //     } finally {
        //         hideLoading()
        //     }
            
        //     showSuccess({
        //         onSuccess: () => {
        //             onClose()
        //         }
        //     })
        // }
    }
    const backBtnClick = () => {
        onClose()
    }

    function validateForm(){
        let isValid = true
        let message = EmptyString

        if (selectedBeneficiaryOptions === null || selectedBeneficiaryOptions === EmptyString){
            message = "Beneficiary Account must be selected"
            isValid = false
        }

        if (selectedTransferSource === null || selectedTransferSource === EmptyString){
            message = "Transfer Source must be selected"
            isValid = false
        }

        if (isValid){
            return true
        }else{  
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }   
                },  
                message: message
            })

            return false
        }
    }
    function fCalculateNetto(amount, mdrInput){
        let xAmount = amount === EmptyString ? 0 : parseFloat(amount.replaceAll(",", ""))
        let xMdr = mdrInput === EmptyString ? 0 : parseFloat(mdrInput)
        let xNetto = xAmount - (xAmount * xMdr / 100)
        setNetto(money(parseInt(xNetto)))
    }

    useEffect(() => {
        showLoading()

        try {
            fetchCustomerPaymentById(customerPaymentId).then((res) => {
                if (!res) return

                let data = res.data

                setCustomerName(data.customerName)
                setCardNumber(data.cardNumber)
                setTransactionDate(data.transactionDate)
                setGesekAmount(data.gesekAmount)
                setTrMdr(data.mdr)
                setNetto(data.netto)
                setRemark(data.remark)
                setAmount(money(data.amount))
                setBankCode(data.bankCode)
                setEdcName(data.edcName)
                setSelectedBeneficiaryOptions({label: data.accountName.toUpperCase() + " - " + data.beneficiaryBankCode + " (" + data.accountNo + ")", value: String(data.beneficiaryId)})
                if (data.paymentBy !== null && data.paymentBy !== "0"){
                    setSelectedTransferSource(transferSourceOptions.find(opt => opt.value === String(data.paymentBy)))
                }                
                setStatus(data.status)
                setCreateDate(data.createDate)
                setUpdateDate(data.updateDate)
                setUpdateBy(data.updateBy)
            })
        } finally {
            hideLoading()
        }
    }, [])

    return (
        <div className="fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center z-40 rounded-lg">
            <div className='z-50 bg-white w-full h-full xl:h-auto xl:w-3/4 2xl:w-1/2 overflow-y-auto shadow-lg rounded-lg p-8'>
                <div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-2xl">Transfer Detail</span>
                        <div className={`gap-2 items-end justify-end hidden sm:flex`}>
                            <span className="text-sm opacity-60">
                                Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                            </span>
                        </div>
                    </div>
                </div>
                <hr />

                <div className="mt-5 flex flex-col gap-3">
                    {/* Customer */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Customer Name</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-[560px]">
                                    <span>{ customerName + " - " + cardNumber }</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Transaction Date */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Transaction Date</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <span>{ moment(transactionDate).format("DD MMMM YYYY")}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mesin EDC */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>EDC</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72 md:w-72">
                                    <span>{ bankCode + " - " + edcName }</span>
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorBeneficiaryAccountNo ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Beneficiary Account No is required!</span>
                        </div>
                    </div>

                    {/* Amount (Jumlah Gesek) */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Amount (Jumlah Gesek)</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <span>{ money(gesekAmount) }</span>
                                </div>
                            </div>
                        </div>
                        <div className={`flex items-center ${ errorMdrOff ? 'block' : 'hidden' }`}>
                            <div className="w-48" />
                            <div className="w-9" />
                            <span className="text-red-500">Mdr Off Us is required!</span>
                        </div>
                    </div>

                    {/* Mdr */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>MDR</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <span>{ trMdr }</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Received Amount */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Received Amount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <span>{ money(netto) }</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Beneficiary */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Beneficiary</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-[560px]">
                                    {formType === "View" ? 
                                        <span>{ selectedBeneficiaryOptions.label }</span>
                                        : 
                                        <Select 
                                            options={beneficiaryOptions} 
                                            value={selectedBeneficiaryOptions} 
                                            onInputChange={beneficiaryOnInput} 
                                            onChange={setSelectedBeneficiaryOptions} 
                                        />
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Amount */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Transfered Amount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    {formType === "View" ? 
                                        <span>{ money(amount) }</span>
                                        : 
                                        <input className="input" value={amount} onChange={amountChange} />
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Transfer Source */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Transfer Source</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-[560px]">
                                    {formType === "View" ? 
                                        <span>{ selectedTransferSource.label }</span>
                                        : 
                                        <Select
                                            value={selectedTransferSource}
                                            options={transferSourceOptions}
                                            onChange={setSelectedTransferSource}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Remark */}
                    <div>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Remark</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    {formType === "View" ? 
                                        <span>{ remark }</span>
                                    :
                                        <input className="input" value={remark} onChange={(e) => { setRemark(e.target.value.toUpperCase()) }} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    {formType === FormTypeEdit && (
                        <>
                            <SaveButton onClick={saveBtnClick} visible={true} />
                            <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                            <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                        </>                        
                    )}
                    
                    <button
                        className="bg-black hover:bg-gray-600 text-white py-2 px-4 rounded-md"
                        onClick={backBtnClick}
                    >
                        <span>Close</span>
                    </button>
                </div>
                
                {/* Modal */}
                {failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
                {loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
                {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
                {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
            </div>

            <div className="fixed top-0 bottom-0 left-0 right-0 bg-app-matte-black opacity-60 z-30" />
        </div>
    )
}